import { fetchPatchCreditCardCardsActions } from '@iwoca/lapi-client/edge';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const usePatchCreditCard = (enfuceCardId: string) => {
    const stateKey = useStateKey();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ action }: { action: string }) =>
            fetchPatchCreditCardCardsActions({
                stateKey,
                enfuceCardId,
                action
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['credit_card_account', stateKey]
            });
        }
    });
};
